"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AppComponent = (function () {
    function AppComponent() {
        this.template = require("./app.html");
        this.controller = AppController;
    }
    return AppComponent;
}());
exports.AppComponent = AppComponent;
var AppController = (function () {
    function AppController($mdSidenav) {
        "ngInject";
        this.$mdSidenav = $mdSidenav;
    }
    AppController.prototype.$onInit = function () { };
    AppController.prototype.openMenu = function () {
        this.$mdSidenav("left").open();
    };
    AppController.prototype.closeMenu = function () {
        this.$mdSidenav("left").close();
    };
    return AppController;
}());
exports.AppController = AppController;



/** WEBPACK FOOTER **
 ** ./src/app/app.component.ts
 **/